
let flag = true;

const ScrollDom = document.querySelector('.scrolls');
const Slide01 = document.querySelector('.slide01');
const Slide02 = document.querySelector('.slide02');
const Slide03 = document.querySelector('.slide03');
const Slide04 = document.querySelector('.slide04');
const Slide05 = document.querySelector('.slide05');
const Slide06 = document.querySelector('.slide06');
const Slide07 = document.querySelector('.slide07');
const Slide08 = document.querySelector('.slide08');
const Slide09 = document.querySelector('.slide09');
const contents = document.querySelectorAll('.slide05_content');

const lottie_element = document.querySelector('.footwork_logo_load');
const shoes = document.querySelector('.shoes');
const spinner = document.querySelector('.loading');
const loadInner = document.querySelector('.percent');
// const logo_load = document.querySelector('.footwork_logo_load');
const Top = document.querySelector('.top');
const wrapper = document.querySelector('.wrapper');
const time = new Date().getTime();

/////////////////// lottie
const lottie01 = () => {
  lottie.loadAnimation({
      container: lottie_element,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      path: 'https://cdn.shopify.com/s/files/1/0611/6445/4120/files/data_aa88731f-3bc3-41f4-922b-b1230dd53b5d.json?v=1700916536'
  });
}
const lottie02 = () => {
  lottie.loadAnimation({
      container: shoes,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: 'https://cdn.shopify.com/s/files/1/0611/6445/4120/files/data_f3b88b5d-dcf8-4183-a358-76e41fb19d30.json?v=1700957411'
  });
}
lottie02();

////////////////// Timer
function Timer(ms) {
  return () =>
    new Promise(resolve => {
      setTimeout(resolve, ms)
    })
}

const init = () => {
  async function main() {
      // window.addEventListener('mousemove', event => onMousemove(event))
      await Timer(100)()
        async function main() {
            await Timer(100)()
            // lottieが終わったあと
            // loadingAnim()
        }
        main()
  }
  main()
}
//////////////// Loading
// loading アニメ
const loadingAnim = () => {
  spinner.classList.add('loaded');
  ScrollDom.classList.add('is-active');
}


// 読み込む画像
// ここあとで読み込む画像を差し替える必要がある
// const images = [
//   'https://cdn.shopify.com/videos/c/o/v/a912646ab35245a8b35824c8c80a8354.mp4',
// ];

const stopload = () => {
  loadInner.classList.add('loaded');
  lottie_element.classList.add('show');
  lottie01();
  async function main() {
      await Timer(2000)();
      if(lottie_element.classList.contains('active')){
        lottie_element.classList.add("loaded");
        gsap.fromTo(
          ".footwork_tag", 
          {
            opacity: 0,scale:3,
          },
          {
            opacity: 1,scale:1, duration: 1,ease: "bounce.out",
          }
        );
        new Vivus( "base08", 
        {
          type: "oneByOne",  
          duration: 150, 
          forceRender: false,
          start: 'autostart',
          animTimingFunction: Vivus.OUT,
        },
        function (obj) {
          obj.el.classList.add("done"); 
        }
      );
        /////////////////// titleをspanで囲む
        const wrapCharSpan = function(str){
          return [...str].map(char => `<span>${char}</span>`).join('');
        }
        const target = document.querySelector('.bg_color');
        target.innerHTML = wrapCharSpan(target.textContent);
        const CLASSNAME = "-visible";
        const TIMEOUT = 500;
        setInterval(() => {
          target.classList.add(CLASSNAME);
        }, TIMEOUT * 2);
      }
      spinner.classList.add('loaded');
      async function main() {
        await Timer(450)()
        init()
      }
      main()
  }
  main()
}

const loadingProp = () => {
  document.addEventListener('DOMContentLoaded', function() {
    console.log("読み込み完了")
    const videoWrappers = document.getElementsByClassName('video_wrapper');
    // for(let i = 0; i < videoWrappers.length; i++) {
        // const videoWrapper = videoWrappers[i];
        const video = videoWrappers[0].getElementsByTagName('video')[0];
        stopload();
        mySwiper.params.noSwiping = false;
        flag = false;
        // video.addEventListener('loadeddata', function() {
        //     var now = new Date().getTime();
        //     if (now - time <= 4000) {
        //       setTimeout('stopload()',2000-(now-time));
        //       flag = false;
        //       mySwiper.params.noSwiping = false;
        //       return;
        //     } else {
        //       stopload();
        //       mySwiper.params.noSwiping = false;
        //       flag = false;
        //     }
        // }, false);
    // }
  }, false);
}
loadingProp();


const mySwiper = new Swiper('.swiper-container', {
  speed: 400,
  preventInteractionOnTransition: 1200,
  noSwiping: 'true',
  // noSwipingClass: 'no-swipe',
  direction: 'vertical',
  effect: 'fade',
  fadeEffect: {
    crossFade: 'true'
  },
});


// scroll表記を最後のスライドの時に消す
mySwiper.on('slideChangeTransitionStart', function () {
  if(Slide09.classList.contains('swiper-slide-active')){
      ScrollDom.classList.add('last');
  }
});
mySwiper.on('slideChangeTransitionEnd', function () {
  if(!Slide09.classList.contains('swiper-slide-active')){
      ScrollDom.classList.remove('last');
  }
});


//// PCの時スクロールしたら
window.addEventListener("wheel", function (event) {
  console.log(flag)
  if (!flag) {
      /////////////////////////////////////////////////////////////////////////////////////////////こっちはしたにスクロール
      if (event.deltaY < 0) {
          async function main() {
              mySwiper.slidePrev();
          }
          main()

          /////////////////////////////////////////////////////////////////////////////////////こっちは上にスクロール
      } else if (event.deltaY > 0) {
          async function main() {
              mySwiper.slideNext();
          }
          main()
      }
      flag = true;
      async function main() {
          // 次にスクロールできるまでの時間
          await Timer(1500)()
          flag = false;
      }
      main()
  }
})

//// scrollアニメーション
const tl = gsap.timeline();
mySwiper.on('slideChangeTransitionStart', function () {
  //slide1枚目
  if(Slide01.classList.contains('swiper-slide-active')){
    lottie_element.classList.remove('loaded');
  }
  //slide2枚目
  if(Slide01.classList.contains('swiper-slide-prev')){
    lottie_element.classList.add('loaded');
    //////////////////////////////////// svgアニメーション
    new Vivus( "base04",
      {
        type: "oneByOne",  
        duration: 50, 
        forceRender: false, 
        start: 'autostart',
        animTimingFunction: Vivus.OUT,
      },
      function (obj) {
        obj.el.classList.add("done"); 
      }
    );
    //////////////////////////////////// 普通のアニメーション
    tl.fromTo(
      ".footwork_about_text",{opacity: 0,},
      {
        opacity: 1,
        delay: 0.3,
        duration: 0.2,
      }
    ).fromTo(".people01",{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    ).fromTo(".people02",{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    ).fromTo(".people03",{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    )
  }
  //slide3枚目
  if(Slide02.classList.contains('swiper-slide-prev')){
    //////////////////////////////////// svgアニメーション
    if (window.matchMedia('(max-width: 767px)').matches) {
      new Vivus( "base2",
      {
        type: "oneByOne",
        duration: 100,
        forceRender: false, 
        start: 'autostart',
        animTimingFunction: Vivus.OUT,
      },
      function (obj) {
        obj.el.classList.add("done"); 
      }
    );
    } else if (window.matchMedia('(min-width:768px)').matches) {
      new Vivus( "base2",
      {
        type: "oneByOne",
        duration: 60,
        forceRender: true, 
        start: 'autostart',
        animTimingFunction: Vivus.OUT,
      },
      function (obj) {
        obj.el.classList.add("done"); 
      }
    );
    }
    tl.fromTo(
      ".name",{opacity: 0,},
      {
        opacity: 1,
        delay: 0.3,
        duration: 0.2,
      }
    ).fromTo(".slide03_text",{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    )
  }
  //slide4枚目
  if(Slide03.classList.contains('swiper-slide-prev')){
    //////////////////////////////////// svgアニメーション
    if (window.matchMedia('(max-width: 767px)').matches) {
      new Vivus( "base7",
      {
        type: "oneByOne",
        duration: 100,
        forceRender: false, 
        start: 'autostart',
        animTimingFunction: Vivus.OUT,
      },
      function (obj) {
        obj.el.classList.add("done"); 
      }
    );
    } else if (window.matchMedia('(min-width:768px)').matches) {
      new Vivus( "base7",
      {
        type: "oneByOne",
        duration: 60,
        forceRender: true, 
        start: 'autostart',
        animTimingFunction: Vivus.OUT,
      },
      function (obj) {
        obj.el.classList.add("done"); 
      }
    );
    }
    tl.fromTo(
      ".name",{opacity: 0,},
      {
        opacity: 1,
        delay: 0.3,
        duration: 0.2,
      }
    ).fromTo(".slide07_text",{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    )
  }
  //slide4_2枚目
  if(Slide07.classList.contains('swiper-slide-prev')){
    //////////////////////////////////// svgアニメーション
    if (window.matchMedia('(max-width: 767px)').matches) {
      new Vivus( "base9",
      {
        type: "oneByOne",
        duration: 100,
        forceRender: false, 
        start: 'autostart',
        animTimingFunction: Vivus.OUT,
      },
      function (obj) {
        obj.el.classList.add("done"); 
      }
    );
    } else if (window.matchMedia('(min-width:768px)').matches) {
      new Vivus( "base9",
      {
        type: "oneByOne",
        duration: 60,
        forceRender: true, 
        start: 'autostart',
        animTimingFunction: Vivus.OUT,
      },
      function (obj) {
        obj.el.classList.add("done"); 
      }
    );
    }
    tl.fromTo(
      ".name",{opacity: 0,},
      {
        opacity: 1,
        delay: 0.3,
        duration: 0.2,
      }
    ).fromTo(".slide08_text",{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    )
  }
  //slide5枚目
  if(Slide08.classList.contains('swiper-slide-prev')){
    //////////////////////////////////// svgアニメーション
    new Vivus( "base06", 
      {
        type: "oneByOne",  
        duration: 50, 
        forceRender: false,
        start: 'autostart',
        animTimingFunction: Vivus.OUT,
      },
      function (obj) {
        obj.el.classList.add("done"); 
      }
    );
    tl.fromTo(
      ".whoisnext",{opacity: 0,},
      {
        opacity: 1,
        delay: 0.3,
        duration: 0.2,
      }
    ).fromTo(".f2",{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    ).fromTo(".f3",{opacity: 0,},
    {opacity: 1,duration: 0.2,}
    )
  }
  //slide6枚目
  if(Slide04.classList.contains('swiper-slide-prev')){
    tl.fromTo(
      ".footwork_about_text",{opacity: 0,},
      {
        opacity: 1,
        delay: 0.3,
        duration: 0.2,
      }
    ).fromTo(contents[0],{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    ).fromTo(contents[1],{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    ).fromTo(contents[2],{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    ).fromTo(contents[3],{opacity: 0,},
      {opacity: 1,duration: 0.2,}
    )
  }
});


